import { type ReactElement } from 'react';

import styles from './NoConversationsMessage.module.scss';

export function NoConversationsMessage(): ReactElement {
  return <p className={styles['no-conversations-message']}>No Chat History</p>;
}
